module.exports = __webpack_public_path__ + "img/icon_kcsp.778a2378.png";